const baseUrl = '/auth'

function login({ redirectBack }: { redirectBack?: string }) {
  let result = `${baseUrl}/login`
  if (!!redirectBack) result += `?rb=${redirectBack}`
  return result
}

const auth = {
  login,
}

export default auth
